import { ConfirmModal } from '../../components/ConfirmModal';
import type { SampleDataRemovalPreview } from '../../types/sampleData';
import { SampleDataSkippedList } from './SampleDataSkippedList';

interface RemoveSampleDataModalProps {
  isOpen: boolean;
  preview: SampleDataRemovalPreview;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirms sample data removal, saying up front what will be kept and why. */
export const RemoveSampleDataModal = ({
  isOpen,
  preview,
  busy,
  onConfirm,
  onClose,
}: RemoveSampleDataModalProps) => (
  <ConfirmModal
    isOpen={isOpen}
    title="Remove sample data"
    message={`This removes ${preview.removable} sample ${
      preview.removable === 1 ? 'record' : 'records'
    } from this organization.`}
    confirmText={busy ? 'Removing...' : 'Remove'}
    busy={busy}
    onConfirm={onConfirm}
    onClose={onClose}
  >
    <SampleDataSkippedList items={preview.skipped} />
    <p className="org-sample-data__note">
      Events already copied by other organizations stay with them.
    </p>
  </ConfirmModal>
);
